function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect } from 'react';
import { useFormFieldWithSelector } from 'formydable';
import InputCore from './InputCore';

const SingleFieldInObjectArray = ({
  name,
  keyName,
  defaultSchema,
  dynamicProps,
  asWrapper: Wrapper = React.Fragment,
  ...props
}) => {
  const {
    fieldState,
    formUpdate,
    setFieldArrays,
    removeFieldArray
  } = useFormFieldWithSelector(name, true);
  const states = fieldState;
  useEffect(() => {
    setFieldArrays(name, defaultSchema, true);
    return () => removeFieldArray(name); // eslint-disable-next-line
  }, [defaultSchema]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, states.map((state, index) => {
    const mapDynamicProps = dynamicProps && dynamicProps(state);
    return /*#__PURE__*/React.createElement(Wrapper, {
      key: index
    }, /*#__PURE__*/React.createElement(InputCore, _extends({
      key: index
    }, props, mapDynamicProps, {
      name: `${name}[${index}].${keyName}`,
      label: state[keyName]?.label,
      onChange: formUpdate,
      state: state[keyName]
    })));
  }));
};

SingleFieldInObjectArray.defaultProps = {};
export default SingleFieldInObjectArray;